import { useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";

// Vous devrez ajouter les images des partenaires dans le dossier assets
// et les importer ici
import partner1 from "@/assets/images/p1.png";
import partner2 from "@/assets/images/p2.png";
import partner3 from "@/assets/images/p3.png";
import partner4 from "@/assets/images/p1.png";
import partner5 from "@/assets/images/p2.png";
import partner6 from "@/assets/images/p3.png";
import partner7 from "@/assets/images/p1.png";
import partner8 from "@/assets/images/p2.png";
import partner9 from "@/assets/images/p3.png";
import partner10 from "@/assets/images/p1.png";
import partner11 from "@/assets/images/p2.png";
import partner12 from "@/assets/images/p3.png";

const partners = [
  { id: 1, logo: partner1, name: "Partenaire 1" },
  { id: 2, logo: partner2, name: "Partenaire 2" },
  { id: 3, logo: partner3, name: "Partenaire 3" },
  { id: 4, logo: partner4, name: "Partenaire 4" },
  { id: 5, logo: partner5, name: "Partenaire 5" },
  { id: 6, logo: partner6, name: "Partenaire 6" },
  { id: 7, logo: partner7, name: "Partenaire 7" },
  { id: 8, logo: partner8, name: "Partenaire 8" },
  { id: 9, logo: partner9, name: "Partenaire 9" },
  { id: 10, logo: partner10, name: "Partenaire 10" },
  { id: 11, logo: partner11, name: "Partenaire 11" },
  { id: 12, logo: partner12, name: "Partenaire 12" },
];

export const Partners = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    loop: true,
    dragFree: true,
    slidesToScroll: 1,
    containScroll: "trimSnaps",
  });

  useEffect(() => {
    if (emblaApi) {
      const interval = setInterval(() => {
        emblaApi.scrollNext();
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [emblaApi]);

  return (
    <div className="max-w-[1350px] mx-auto px-4 mobile:px-2">
      <h2 className="text-3xl mobile:text-2xl font-bold mb-4 mobile:mb-2">
        Nos Partenaires
      </h2>
      <div className="w-full overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="flex-[0_0_33.333333%] md:flex-[0_0_20%] min-w-0 px-2"
            >
              <div className="p-4">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="w-full h-16 object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
